const steps = [
  { no: "STEP 01", title: "定关键词", desc: "先想清楚你要查的「黑料关键词」，越具体命中越准。" },
  { no: "STEP 02", title: "发起查找", desc: "在顶部搜索框输入关键词，或直接点按检索热词、热榜词。" },
  { no: "STEP 03", title: "锁定专题", desc: "系统按相关性返回专题合集与内容查询结果，扫封面即可筛选。" },
  { no: "STEP 04", title: "领域下钻", desc: "仍在同一领域继续查找，可在六大分区内二次筛选与追更。" },
];

export default function Guide() {
  return (
    <section id="guide" className="scroll-mt-24 bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-compass-3-line text-sm"></i>使用指引 · 检索主线
          </div>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            怎么用网黑料快速找到目标内容
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
            无论查专题还是做内容查询，记住「关键词 → 专题 → 领域」这条主线即可。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div
              key={s.no}
              className="relative overflow-hidden rounded-xl border border-background-200/80 bg-background-50 p-5 md:p-6"
            >
              <span className="font-heading text-5xl font-black text-background-100">{`0${i + 1}`}</span>
              <p className="mt-2 text-[11px] font-bold tracking-widest text-primary-500">{s.no}</p>
              <h3 className="mt-1 font-heading text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-[13px] leading-6 text-foreground-600">{s.desc}</p>
              {i < steps.length - 1 && (
                <i className="ri-arrow-right-line absolute right-4 top-6 hidden text-2xl text-background-200 lg:block"></i>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col items-center gap-3 rounded-xl border border-accent-200 bg-accent-50 px-5 py-4 text-center sm:flex-row sm:justify-between sm:text-left">
          <p className="flex items-center gap-2 text-sm text-accent-900">
            <i className="ri-information-line text-lg"></i>
            本页为聚合索引门户，专题与内容持续归档更新，检索更省力。
          </p>
          <a
            href="#"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600"
          >
            <i className="ri-arrow-up-line"></i>回到顶部检索
          </a>
        </div>
      </div>
    </section>
  );
}